import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { Toaster } from '@/components/ui/sonner';
import Layout from '@/components/Layout';
import Home from '@/pages/Home';
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import PromptDetail from '@/pages/PromptDetail';
import SubmitPrompt from '@/pages/SubmitPrompt';
import SubmitPlatform from '@/pages/SubmitPlatform';
import Profile from '@/pages/Profile';
import Categories from '@/pages/Categories';
import Platforms from '@/pages/Platforms';
import PlatformDetail from '@/pages/PlatformDetail';
import Bookmarks from '@/pages/Bookmarks';
import LLMCostCalculator from '@/pages/LLMCostCalculator';
import AdminDashboard from '@/pages/AdminDashboard';
import '@/App.css';

function App() {
  useEffect(() => {
    document.title = "PromptVault - Community-driven AI prompt library. Discover, share, and upvote the best AI prompts.";
  }, []);
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/prompt/:id" element={<PromptDetail />} />
              <Route path="/submit" element={<SubmitPrompt />} />
              <Route path="/submit-platform" element={<SubmitPlatform />} />
              <Route path="/profile/:userId" element={<Profile />} />
              <Route path="/categories" element={<Categories />} />
              <Route path="/platforms" element={<Platforms />} />
              <Route path="/platform/:slug" element={<PlatformDetail />} />
              <Route path="/bookmarks" element={<Bookmarks />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/LLM-Cost-Calculator" element={<LLMCostCalculator />} />
            </Routes>
          </Layout>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
